module.exports = __webpack_public_path__ + "img/p8.47a4b0d5.png";